<template>
    <div class="summary-page">
        <h2 class="table-title">
            Summary
        </h2>
        <CompanyDropdown></CompanyDropdown>
        <div class="content-table">
            <table>
                <!-- main title comp -->
                <titleTable></titleTable>
                <dataTable></dataTable>
                <!-- title table -->
            </table>
        </div>
        <div class="content-table">
            <table>
                <!-- main title comp -->
                <titleTableNDW></titleTableNDW>
                <dataTableNDW></dataTableNDW>
                <!-- title table -->
            </table>
        </div>
    </div>
</template>

<script>
import TitleTable from "../components/summary/TitleTable.vue";
import DataTable from "../components/summary/DataTable.vue";
import TitleTableNDW from "../components/summary/TitleTable_NDW.vue";
import DataTableNDW from "../components/summary/DataTable_NDW.vue";
import CompanyDropdown from "../components/summary/CompanyDrop.vue";
import '../styles/styles.scss';
import axios from "axios";


export default {
    name: 'App',
    data() {
        return {
			customer: "",
            list: []
        }
    },
	methods: {
		async getSummaryList() {
			//let result = await axios.get('https://new.colorwayrb.com/backend/summary.php?sessionid=' + (this.$store.getters.sessionid)) + '&customer=' + this.customer
			let result = await axios.get('https://new.colorwayrb.com/backend/summary.php?sessionid=' + (this.$store.getters.sessionid))
			var allItems = result.data

			//Finds all Drinkware
			var drinkware = allItems.filter(function (el) {
				return el.isDrinkware == true;
			})

			//Data into date arrays
			var ids = drinkware.map(e => e.date).filter((x, i, a) => a.indexOf(x) == i);
			var drinkwareDates = {};

			ids.forEach(i => {
				drinkwareDates[i] = drinkware.filter(e => {
					return e.date === i;
				});
			});

			//Finds key for dates e.g keys[1]
			var keys = Object.keys(drinkwareDates);
			//console.log(drinkwareDates)

			var smallMugs = [];
			for (var i = 0; i < keys.length; i++) {

				//Filter 11oz Mugs
				var mugs11Oz = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'Mug 11oz';
				})

				//Filter 15oz Mugs
				var mugs15Oz = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'GN0601017-2574B';
				})

				//Filter Steel Mugs
				var steelMug = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'steel mug';
				})

				//Filter Special Mugs
				var specialMug = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'steel bottle';
				})

				//Filter Steel Bottle
				var steelBottle = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'special mug';
				})

				//Gets reaming and total sums 11oz Mugs
				var mugs11OzRemainAmount = 0;
				var mugs11OzTotalAmount = 0;
				mugs11Oz.forEach(function (el) {
					mugs11OzRemainAmount = mugs11OzRemainAmount + el.qty.remain
					mugs11OzTotalAmount = mugs11OzTotalAmount + parseInt(el.qty.total);

					return mugs11OzRemainAmount, mugs11OzTotalAmount
				})

				//Gets reaming and total sums 11oz Mugs
				var mugs15OzRemainAmount = 0;
				var mugs15OzTotalAmount = 0;
				mugs15Oz.forEach(function (el) {
					mugs15OzRemainAmount = mugs15OzRemainAmount + el.qty.remain
					mugs15OzTotalAmount = mugs15OzTotalAmount + parseInt(el.qty.total);

					return mugs15OzRemainAmount, mugs15OzTotalAmount
				})

				//Gets reaming and total sums Steel Mugs
				var steelMugRemainAmount = 0;
				var steelMugTotalAmount = 0;
				steelMug.forEach(function (el) {
					steelMugRemainAmount = steelMugRemainAmount + el.qty.remain
					steelMugTotalAmount = steelMugTotalAmount + parseInt(el.qty.total);

					return steelMugRemainAmount, steelMugTotalAmount
				})

				//Gets reaming and total sums Steel Mugs
				var specialMugRemainAmount = 0;
				var specialMugTotalAmount = 0;
				specialMug.forEach(function (el) {
					specialMugRemainAmount = specialMugRemainAmount + el.qty.remain
					specialMugTotalAmount = specialMugTotalAmount + parseInt(el.qty.total);

					return specialMugRemainAmount, specialMugTotalAmount
				})

				//Gets reaming and total sums Steel Bottle
				var steelBottleRemainAmount = 0;
				var steelBottleTotalAmount = 0;
				steelBottle.forEach(function (el) {
					steelBottleRemainAmount = steelBottleRemainAmount + el.qty.remain
					steelBottleTotalAmount = steelBottleTotalAmount + parseInt(el.qty.total);

					return steelBottleRemainAmount, steelBottleTotalAmount
				})

				var totalRemain = mugs11OzRemainAmount + mugs15OzRemainAmount + steelMugRemainAmount + specialMugRemainAmount + steelBottleRemainAmount
				var allTotal = mugs11OzTotalAmount + mugs15OzTotalAmount + steelMugTotalAmount + specialMugTotalAmount + steelBottleTotalAmount


				var dates = drinkwareDates[keys[i]][0].date

				var samllItems = {
					'date': dates,
					'mug11remain': mugs11OzRemainAmount,
					'mug11total': mugs11OzTotalAmount,
					'mug15remain': mugs15OzRemainAmount,
					'mug15total': mugs15OzTotalAmount,
					'steelmugremain': steelMugRemainAmount,
					'steelmugtotal': steelMugTotalAmount,
					'specialmugremain': specialMugRemainAmount,
					'specialmugtotal': specialMugTotalAmount,
					'steelbottleremain': steelBottleRemainAmount,
					'steelbottletotal': steelBottleTotalAmount,
					'totalremain': totalRemain,
					'alltotal': allTotal


				}
				smallMugs.push(samllItems)
				console.log(drinkwareDates[keys[i]])
			}
			this.list = smallMugs
			//console.log(names)
			console.log(smallMugs)




			//Single date array
			//var day1test = drinkwareDates[keys[1]]

			//Filter SKU
			// var smallMug = drinkwareDates[keys[1]].filter(function (el) {
			//     return el.sku == 'Mug 11oz';
			// })
			// console.log(smallMug)



			//Gets reaming and total sums
			// var remainAmount = 0;
			// var totalAmount = 0;
			// smallMug.forEach(function (el) {
			//     remainAmount = remainAmount + el.qty.remain

			//     totalAmount = totalAmount + parseInt(el.qty.total);
			//     return remainAmount, totalAmount
			// })

			//var totalRemaining = remainAmount
			//var dayTotal = totalAmount
			//console.log(totalRemaining)
			//console.log(dayTotal)






			// var notDrinkware = allItems.filter(function (el) {
			//     return el.isDrinkware == false;
			// })
			// console.log(notDrinkware)
			// for (let i = 0; i < drinkware.length && i < 1; i++) {
			//     drinkware.forEach(element => {
			//         if (element.date == '2022-08-03') {
			//             console.log(drinkware)
			//         }
			//     });
			// }

			// drinkware.forEach(element => {
			//     if (element.date == '2022-08-03') {
			//         console.log(drinkware)
			//     }
			// });
		
		}
	},
    mounted() {
	
        //this.getSummaryList();
		

    },
    components: {
        CompanyDropdown,
        TitleTable,
        DataTable,
		TitleTableNDW,
		DataTableNDW,
    }
}


</script>

<style>
.table-dev {
    text-align: center;
}

.table-dev th {
    padding-left: 20px;
}
</style>